import React from "react";

function Hero() {
  return (
    <div className="container border-bottom mb-5">
        <div className="row text-center mt-5 p-5">
      <h2>Zerodha Products</h2>
      <h3 className="mt-1 fs-5 text-muted">Sleek, modern, and intuitive trading platforms</h3>
      <p className="mt-3">
        Check out our{" "}
        <a href="" style={{ textDecoration: "none" }}>
          investment offerings →
        </a>
      </p>
      </div>
    </div>
  );
}

export default Hero;
